export default __webpack_public_path__ + "static/media/Aeonik-SemiBoldItalic.4d1dc42f.woff";